// extracted by mini-css-extract-plugin
module.exports = {"areaProfile":"AreaProfile_areaProfile__YRVT4"};